import { MenuItem, Select } from "@mui/material";

/**
 * Rodiklio select listas
 * @param {*} rodiklis pasirinktas rodiklio objektas pagal constants/Rodikliai.js struktura
 * @param {[]} rodikliuList visu galimu rodiklio objektu pasirinkimas
 * @param {() => {}} changeRodiklis set funckija, kuri pakeicia busena
 * @param {boolean} fullWidth paduoti true, jei select listas turi uzimti visi ilgi
 * @returns
 */
const RodiklioSelect = ({ rodiklis, rodikliuList, changeRodiklis, fullWidth }) => {
  const handleChangeInput = (value) => {
    let result = rodikliuList.find((r) => r.parametras === value);
    changeRodiklis(result ? result : rodikliuList[0]);
  };

  return (
    <Select
      id="rodiklis"
      name="rodiklis"
      value={rodiklis.parametras}
      size="small"
      onChange={(e) => handleChangeInput(e.target.value)}
      fullWidth={fullWidth}
    >
      {rodikliuList.map((r) => (
        <MenuItem key={r.parametras} value={r.parametras}>
          {r.pavadinimas}
        </MenuItem>
      ))}
    </Select>
  );
};

export default RodiklioSelect;
